import React, { useState } from "react";
import { Row, Col, Modal, Button } from "antd";
import { motion } from "framer-motion";
import "./logodesgin.css";

// Import images from the local folder
import logo1 from "../Asset/poster/logo1.jpg";
import logo2 from "../Asset/poster/logo2.jpg";
import logo3 from "../Asset/poster/logo3.png";
import logo4 from "../Asset/poster/logo4.jpg";
import logo5 from "../Asset/poster/logo5.png";
import logo6 from "../Asset/poster/logo6.png";
const photos = [
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,

  // Add more photos as needed
];

const Poster = () => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const handleOpenModal = (photo) => {
    setSelectedPhoto(photo);
  };

  const handleCloseModal = () => {
    setSelectedPhoto(null);
  };

  return (
    <div className="logo-container">
      <div className="wave wave1"></div>
      <div className="wave wave2"></div>
      <div className="wave wave3"></div>

      <h1 className="page-title">Poster Design</h1>

      <Row gutter={[16, 16]} justify="center">
        {photos.map((photo, index) => (
          <Col key={index} xs={24} sm={12} md={8} lg={6}>
            <motion.div
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={() => handleOpenModal(photo)}
              style={{
                borderRadius: "8px",
                overflow: "hidden",
                cursor: "pointer",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              }}
            >
              <img
                src={photo}
                alt={`Photo ${index + 1}`}
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "8px",
                  transition: "transform 0.3s ease",
                }}
              />
            </motion.div>
          </Col>
        ))}
      </Row>

      <Modal
        visible={selectedPhoto !== null}
        onCancel={handleCloseModal}
        footer={null}
        centered
        width={800}
      >
        <img
          src={selectedPhoto}
          alt="Selected"
          style={{
            width: "100%",
            height: "auto",
            borderRadius: "8px",
          }}
        />
        <Button
          type="primary"
          onClick={handleCloseModal}
          style={{ marginTop: "10px", width: "100%" }}
        >
          Close
        </Button>
      </Modal>
    </div>
  );
};

export default Poster;
